export { surfaceDocumentSchema, type SurfaceDocument } from './types';
export {
  isValidatedSurfaceDocument,
  markValidatedSurfaceDocument,
  resolveSyncSurfaceDocument,
  type SyncSurfaceResolveRequest,
  type SyncSurfaceSource,
} from './source';
export { homeSurfaceResponseSchema, type HomeSurfaceResponse } from './home-surface-response';
export {
  homeRegionOutcomeSchema,
  homePresentationRegionsSchema,
  homePresentationDataSchema,
  homePresentationResponseSchema,
  type HomeRegionOutcome,
  type HomePresentationRegions,
  type HomePresentationData,
} from './home-presentation-response';
